import store from "../../store";
import { csvToArray } from "./utils";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

class AmfX {
    constructor() {
    }

    clone(moduleName, properties) {
        var moduleState = getModuleByPath(store, moduleName)._rawModule["state"];

        if (properties == "*" || properties == "state.*") {
            properties = _.keys(moduleState);
        } else {
            properties = csvToArray(properties);
        }

        _.remove(properties, function (p) { return p == "hash" });

        let result = {};
        properties.forEach(p => {
            if (_.isUndefined(moduleState[p])) throw `State property '${p}' not found`;
            result[p] = _.cloneDeep(moduleState[p]);
        });
    
        return result;
    }
    
    copy(moduleName, properties, copyTo) {
        let obj = this.clone(moduleName, properties);
        if (obj["hash"]) delete obj["hash"];
        _.assign(copyTo, obj);
    }

    computed(arg1, arg2) {
        return this.map(arg1, arg2, "computed");
    }

    methods(arg1, arg2) {
        return this.map(arg1, arg2, "methods");
    }

    map(arg1, arg2, mappingSection) {
        if (arg1 === undefined || arg2 === undefined) 
            throw "amfx.map requires two arguments";

        if (mappingSection && mappingSection != "computed" && mappingSection != "methods") 
            throw "amfx.map third argument should be 'computed' or 'methods' or undefined: " + mappingSection;

        let moduleName = arg1;
        let properties = arg2;

        if (_.isString(arg2) && arg2.indexOf(".*") > 0) {
            let type = arg2.split(".")[0];
            properties = _.keys(getModuleByPath(store, moduleName)._rawModule[type]);
        }
        else {
            properties = csvToArray(arg2);
        }
        
        let getPropertiesByType = (type) => {
            var propertiesOfType = getModuleByPath(store, moduleName)._rawModule[type] || [];
            return  _.filter(properties, p => propertiesOfType[getRealPropertyName(p)] !== undefined)
        }

        let types = ["state", "actions", "mutations", "getters"];

        let propertiesByType = {};
        types.forEach(t => propertiesByType[t] = getPropertiesByType(t));

        let vuexMappers = { state: mapState, actions: mapActions, mutations: mapMutations, getters: mapGetters }

        let recognizedProperties = []; 
        types.forEach(t => { recognizedProperties = recognizedProperties.concat(propertiesByType[t]); });

        if (recognizedProperties.length != properties.length) {
            var difference = _.union(_.difference(recognizedProperties, properties), _.difference(properties, recognizedProperties));
            throw "State, getter or action not found: " + difference.join(",");
        }

        if (propertiesByType["actions"].length + propertiesByType["mutations"].length > 0 
            && propertiesByType["getters"] + propertiesByType["state"].length > 0) {
            throw "Mixing actions/mutations with getter/state is not allowed: " + properties.join(",");
        }

        if(propertiesByType["actions"].length && propertiesByType["actions"].includes("load")) {
            throw "Mapping the load method is not allowed. The load method is reserved for components. Dispatch the method through the store";
        }
        
        let mappings = {};

        types.forEach(t => {
            propertiesByType[t].forEach(p => {
                let m = {};

                var mappedPropertyName = getMappedPropertyName(p);

                validateMappingSection(mappingSection, mappedPropertyName, t);

                m[mappedPropertyName] = getRealPropertyName(p);

                if (moduleName)
                    mappings = {...mappings, ...vuexMappers[t](moduleName, m) };
                else
                    mappings = {...mappings, ...vuexMappers[t](m) };
            });
        });

        return mappings;
    }    

}

const amfx = new AmfX();

function getModuleByPath (store, path, parentModule) {
    if (!parentModule) parentModule = store._modules.root;
    if (!path) return store._modules.root;

    let moduleName = path.split("/")[0];

    if (parentModule._children[moduleName]) {
        if (path.indexOf("/") > 0) {
            let remainingPath = path.split("/").slice(1).join("/");
            return getModuleByPath(store, remainingPath, parentModule._children[moduleName]);
        } else {
            return parentModule._children[moduleName];
        }
    } else {
        throw `Child store ${path} not found`;
    }
}

function validateMappingSection(mappingSection, mappedPropertyName, propertyType) {
    if ((propertyType == "state" || propertyType == "getters") && mappingSection && mappingSection != "computed") 
        throw `${mappedPropertyName} must be mapped in computed.`;

    if ((propertyType == "actions" || propertyType == "mutations") && mappingSection && mappingSection != "methods") 
        throw `${mappedPropertyName} must be mapped in methods.`;
}

function getMappedPropertyName(prop) {
    if (prop.indexOf(":") > 0) { 
        return _.trim(prop.split(":")[0]);
    } else {
        return prop;
    }
}

function getRealPropertyName(prop) {
    if (prop.charAt(0) == "x" && prop.charAt(1) == (prop.charAt(1).toUpperCase())) {
        return _.lowerFirst(prop.substring(1));
    } if (prop.indexOf(":") > 0) { 
        return _.trim(prop.split(":")[1]);
    } else {
        return prop;
    }
}

export { amfx };



// WEBPACK FOOTER //
// ./src/framework/utils/amfx.js